$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

jQuery(function ($) {

    $(".page-single article .gallery br").remove();

    // --- NOTICE ALERT ---
    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });

    $(document.body).trigger('wc_fragment_refresh');

});

